import { useQuery } from '@tanstack/react-query';
import { useLocation, useSearchParams } from 'react-router-dom';

import { clientDetailApi } from '@/api/client-detail';
import { Header } from '@/components/Header';
import { GuestDownloadApprovalPanel } from './GuestDownloadApprovalPanel';
import { ReleaseDownloadGrantsPanel } from './ReleaseDownloadGrantsPanel';

export function InstallersPage() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const fixedClientId = Number(searchParams.get('clientId') || 0) || null;
  const stateClientName =
    typeof location.state === 'object' && location.state && 'clientName' in location.state
      ? String((location.state as { clientName?: unknown }).clientName || '')
      : '';
  const fixedClient = useQuery({
    queryKey: ['client-detail', fixedClientId],
    queryFn: () => clientDetailApi.getMobileDetail(fixedClientId!),
    enabled: !!fixedClientId,
  });
  const fixedClientName = fixedClient.data?.client.name || stateClientName;
  const backTo = fixedClientId ? `/visits/client/${fixedClientId}?tab=licensing&licensingSection=installers` : '/more';

  return (
    <div className="min-h-full bg-background">
      <Header
        title="Установщики"
        subtitle={fixedClientName || (fixedClientId ? `Клиент ${fixedClientId}` : undefined)}
        showBack
        backTo={backTo}
      />

      <main className="p-4 space-y-4">
        <GuestDownloadApprovalPanel fixedClientId={fixedClientId ?? undefined} clientName={fixedClientName} />

        {fixedClientId && (
          <ReleaseDownloadGrantsPanel clientId={fixedClientId} clientName={fixedClientName} />
        )}
      </main>
    </div>
  );
}
